// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"fd528cd9","224":"00c310ef","375":"9c3f538d","501":"c0d5f668","990":"3236f8eb"}[chunkId] + ".chunk.css";
};